/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedGenderDropdown200,
  GetApiV1PersonSharedGenderDropdown401,
  GetApiV1PersonSharedGenderDropdown500,
  GetApiV1PersonSharedGenderDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedGenderDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedGenderDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedGenderDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedGenderDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedGenderDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedGenderDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedGenderDropdown500>;

export const getApiV1PersonSharedGenderDropdownQueryResponseSchema = z.lazy(
  () => getApiV1PersonSharedGenderDropdown200Schema,
) as unknown as ToZod<GetApiV1PersonSharedGenderDropdownQueryResponse>;
